<!--
component: BrowseBuildingKanri
author: Ken Nakamura
description: 建築計画概要書（第一面 監理者）
-->
<template>
  <section>
    <div v-show="startIndex==0 && endIndex>0" class="gaiyo-row">
      <hr>
      <div class="gaiyo-major-title">
      【5.工事監理者】
      </div>
    </div>
    <div v-for="(kanri, index) in kanris" :key="index">
      <div v-show="index>=startIndex && index<endIndex" class="person-block">
      <div class="gaiyo-row">
        <div v-show="index==0" class="gaiyo-person-type">（代表となる工事監理者）</div>
        <div v-show="index==1" class="gaiyo-person-type">（その他の工事監理者）</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ｲ.資格】</div>
        <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(kanri.knrsY_SKK_SKBT)}}</div>
        <div class="gaiyo-element left-65">）建築士</div>
        <div class="gaiyo-element left-90">（{{getRegister(kanri.knrsY_TRK_KKN)}}</div>
        <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{kanri.knrsY_TRK_NO}}&nbsp;号
        </div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾛ.氏名】</div>
        <div class="gaiyo-element left-45">{{kanri.knrsY_NAME}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾊ.建築士事務所名】</div>
        <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(kanri.knrjM_SKK_SKBT)}}</div>
        <div class="gaiyo-element left-65">）建築士事務所</div>
        <div class="gaiyo-element left-90">（{{getRegister(kanri.knrjM_TRK_KKN)}}</div>
        <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{kanri.knrjM_TRK_NO}}&nbsp;号</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-element left-45">{{kanri.knrjM_NAME}}</div>
        <div v-for="(n,index) in wordwrap(kanri.knrjM_NAME,40)" :key="`knrjm-name-${index}`">
          <br v-show="index>0"></div>
      <br></div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾆ.郵便番号】</div>
        <div class="gaiyo-element left-45">{{kanri.knrjM_POSTNO}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾎ.所在地】</div>
        <div class="gaiyo-element left-45">{{kanri.knrjM_ADDR}}</div>
        <div v-for="(n,index) in wordwrap(kanri.knrjM_ADDR,40)" :key="`knrjm-addr-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾍ.電話番号】</div>
        <div class="gaiyo-element left-45">{{kanri.knrjM_TELNO}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾄ.工事と照合する設計図書】</div>
        <div class="gaiyo-element left-60">{{kanri.bK_NAME}}</div>
        <div v-for="(n,index) in wordwrap(kanri.bK_NAME,34)" :key="`kanri-bkname-${index}`">
          <br v-show="index>0"></div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../../common/constants'

export default {
  props: {
    kanris: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0
    },
    endIndex: {
      type: Number,
      default: () => 99
    }
  },
  computed: {
  },
  methods: {
    getShikaku(code) {
      const shikaku = constants.shikakuKubun[code];
      if (shikaku == null) {
        return '';
      }
      else {
        return shikaku.name;
      }
    },
    getRegister(code) {
      const rgst = constants.Register[code];
      if (rgst == null) {
        return '';
      }
      else {
        return rgst.name;
      }
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/common/common.css";
</style>